import { toDay } from "../analytics/charts/charts.utils";

import type { SessionByDay } from "@/src/api/StatsAPI.types";

import type { TimelineDatum } from "../analytics/charts/charts.types";

export type SessionsKey = "sessions";

export function buildSessionsTimeline(
  response: SessionByDay[] | undefined,
): TimelineDatum<SessionsKey>[] {
  return (response ?? []).map((item) => ({
    date: toDay(item.date),
    values: { sessions: item.sessions_count },
  }));
}
